export default __webpack_public_path__ + "static/media/Home_IMG-Property.461147e8.png";